module.exports = __webpack_public_path__ + "static/media/AirbnbCerealApp-Book.3ce4aa30.woff";